import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/answer-likert.action'
import answerLikertEdit from 'api/answers/likerts/Edit'
import { IAnswerLikertModel } from 'models/answerLikert.model'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

async function answerLikert(data: IAnswerLikertModel) {
  return await answerLikertEdit(data)
}

function* AnswerLikertEffectSaga(action: any) {
  try {
    const { data } = yield call(answerLikert, action.payload)
    yield put(fromActions.Actions.answerLikertEditSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* answerLikertEditWatcherSaga() {
  yield takeLatest(fromActions.ANSWER_LIKERT_EDIT, AnswerLikertEffectSaga)
}
